import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';
import {useIntl} from 'react-intl';
import Field from '@fo/designSystem/Fields/Field/Field';
import {Field as FieldType} from '@fo/designSystem/Fields/types';

import fieldStyles from '@fo/designSystem/Fields/Field/Field.styles';

interface Props extends FieldType {
  maxLength?: number;
  labelClassName?: string;
  labelTestId?: string;
}

function Email({
  name,
  label,
  errorMessage = '',
  assistiveMessage = '',
  onChange,
  onBlur = () => {
    /* noop */
  },
  placeholder = '',
  value,
  maxLength = 80,
  warningMessage = '',
  isDisabled,
  labelClassName,
  testId,
  className,
  labelTestId,
}: Props): ReactElement {
  const {formatMessage} = useIntl();

  const hasWarning = !!warningMessage;
  const hasError = !!errorMessage;

  return (
    <Field
      name={name}
      label={label}
      errorMessage={errorMessage}
      warningMessage={warningMessage}
      assistiveMessage={assistiveMessage}
      isDisabled={isDisabled}
      className={className}
      labelClassName={labelClassName}
      labelTestId={labelTestId}
    >
      <input
        className={cx(fieldStyles.input(hasWarning, hasError, isDisabled))}
        id={name}
        aria-label={formatMessage({id: 'phoenix.fields.email.ariaLabel'})}
        type="email"
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        value={value}
        maxLength={maxLength}
        disabled={isDisabled}
        data-disabled={isDisabled}
        data-testid={testId}
      />
    </Field>
  );
}

export default Email;
